import { ExtendedTheme } from 'parkdepot-shared/theme'
import { BadgeVariant } from './types'

export const colourMapping: (
    $theme: ExtendedTheme
) => Record<BadgeVariant, { main: string; secondary: string; background: string }> = ($theme) => ({
    positive: {
        main: $theme.colors.green700,
        secondary: $theme.colors.green400,
        background: $theme.colors.green500
    },
    negative: {
        main: $theme.colors.red700,
        secondary: $theme.colors.red600,
        background: $theme.colors.red50
    },
    warning: {
        main: $theme.colors.warning600,
        secondary: $theme.colors.warning100,
        background: $theme.colors.warning50
    },
    information: {
        main: $theme.colors.primary,
        secondary: $theme.colors.blue200,
        background: $theme.colors.blue100
    },
    default: { main: $theme.colors.mono400, secondary: $theme.colors.mono300, background: $theme.colors.mono200 }
})
